import Model from "./abstract/Model";

export default class ContractCancellation extends Model {

  country_ids;

  constructor(props) {
    super();

    this.initializeAttributes(props, {
    });
  }
}
